import { GET_ALL_PROFILE_LANGUAGES } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_PROFILE_LANGUAGES:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAllProfileLanguages.js